import React from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { UploadFieldBlock } from '../../blocks'
import TimeInput from '../../time-input'
import Title from './field-title'
import { MIN_OUTPUT_VIDEO_DURATION, MAX_OUTPUT_VIDEO_DURATION } from '../../../constants'

const Timer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`

const Container = styled.div`
    display: flex;
`

const Label = styled.span`
    padding-right: 10px;
`

type Props = {
    className?: string
    field: CreationToolSuperCutField
    defaultMinLength: number
    defaultMaxLength: number
    onMinLengthChange: (length: number) => void
    onMaxLengthChange: (length: number) => void
}

const CreationCaptureSegmentationTimingField = ({
    className,
    field,
    defaultMinLength,
    defaultMaxLength,
    onMinLengthChange,
    onMaxLengthChange,
}: Props) => {
    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <Container>
                <Timer>
                    <Label>Min Length:</Label>
                    <TimeInput
                        {...{
                            value: defaultMinLength,
                            min: MIN_OUTPUT_VIDEO_DURATION,
                            max: defaultMaxLength - MIN_OUTPUT_VIDEO_DURATION, // adding a buffer from the end to prevent the duration from being 0
                            onUpdate: seconds => onMinLengthChange(seconds),
                        }}
                    />
                </Timer>
                <Timer>
                    <Label>Max Length:</Label>
                    <TimeInput
                        {...{
                            value: defaultMaxLength,
                            min: defaultMinLength + MIN_OUTPUT_VIDEO_DURATION, // adding a buffer from the end to prevent the duration from being 0
                            max: MAX_OUTPUT_VIDEO_DURATION,
                            onUpdate: seconds => onMaxLengthChange(seconds),
                        }}
                    />
                </Timer>
            </Container>
        </UploadFieldBlock>
    )
}

export default CreationCaptureSegmentationTimingField
